module.exports = {"pathContext":{}}


//////////////////
// WEBPACK FOOTER
// ./~/json-loader!./.cache/json/examples.json
// module id = 803
// module chunks = 20261293278027